// The ONE password policy, shared by the API (server-side gate) and the web
// (per-rule checklist meter). It lived duplicated in
// packages/api/src/account/password-policy.ts and the web's
// reset-password-data.ts with a comment begging them to stay in lockstep —
// this module is the lockstep.
//
// Architecture §5.2 also wants a zxcvbn >= 3 strength gate; that's a Phase-2
// add — the four char-class rules are the Phase-1 contract the UI enforces.

export interface PasswordRule {
  id: string
  /** MX-Spanish label rendered by the web checklist meter. */
  label: string
  test: (pw: string) => boolean
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'Mínimo 12 caracteres', test: (pw) => pw.length >= 12 },
  { id: 'upper', label: 'Una mayúscula', test: (pw) => /[A-ZÁÉÍÓÚÑ]/.test(pw) },
  { id: 'number', label: 'Un número', test: (pw) => /\d/.test(pw) },
  { id: 'symbol', label: 'Un símbolo', test: (pw) => /[^A-Za-z0-9ÁÉÍÓÚÑáéíóúñ]/.test(pw) },
]

/** True when a password satisfies every rule (≥12 chars, uppercase, digit, symbol). */
export function passwordMeetsPolicy(pw: string): boolean {
  return PASSWORD_RULES.every((r) => r.test(pw))
}
